// Cents the SERVER sent, or null when it sent none. null/undefined/'' are
// "no quote", never zero - Number(null) is 0 and must not become "$0.00".
// Formatting only; no money is ever computed in the browser.
export const parseCents = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const formatCents = (value) => {
  const cents = parseCents(value);
  return cents === null ? null : (cents / 100).toFixed(2);
};
